import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Filter from '../../containers/Filter/Filter';
import Filters from '../../containers/Filters/Filters';
import { getPermissions } from '../../utils/getPermissions';

function DeviceFilters(props) {
  const {
    auth,
    users: { users },
    devices: {
      devices: { facet_fields },
    },
    toggleMoreFilters,
    showMoreFilters,
  } = props;
  const p = getPermissions(auth);

  if (!facet_fields || !Object.keys(facet_fields).length) {
    return null;
  }

  const {
    // device status
    online_status,
    download_status,
    health_status,
    prestaged,
    version,
    firmware_version,
    device_type,
    override_download_schedule,
    healthcheck_config_name,
    // general
    download_interval,
    hardware_rotation,
    rotation,
    viewport_top_left,
    fps_limit,
    is_default,
    commander_enabled,
    // video wall
    synchronisation_method,
    sync_tag,
    time_sync,
    vw_enabled,
    vw_left,
    vw_top,
    vw_width,
    vw_height,
    vw_wall_width,
    vw_wall_height,
    // power schedules
    restart_enabled,
    restart_hour,
    restart_min,
    power_schedule_enabled,
    power_schedule_mon_1_on,
    power_schedule_mon_1_off,
    power_schedule_tue_1_on,
    power_schedule_tue_1_off,
    power_schedule_wed_1_on,
    power_schedule_wed_1_off,
    power_schedule_thu_1_on,
    power_schedule_thu_1_off,
    power_schedule_fri_1_on,
    power_schedule_fri_1_off,
    power_schedule_sat_1_on,
    power_schedule_sat_1_off,
    power_schedule_sun_1_on,
    power_schedule_sun_1_off,
    power_schedule_extra_1_key,
    power_schedule_extra_1_val,
    power_schedule_extra_2_key,
    power_schedule_extra_2_val,
    power_schedule_extra_3_key,
    power_schedule_extra_3_val,
    power_schedule_extra_4_key,
    power_schedule_extra_4_val,
    power_schedule_extra_5_key,
    power_schedule_extra_5_val,
    // diagnostics
    debug_toast,
    save_errors,
    show_progress,
    error_marker,
    network_status_marker,
    show_stats,
    network_watchdog,
    // external
    allow_external_update,
    broadcast,
    broadcast_port,
    // metadata
    createdBy,
    modifiedBy,
    tags,
  } = facet_fields;
  const enabledText = { 0: 'Disabled', 1: 'Enabled', false: 'Disabled', true: 'Enabled' };
  const syncText = { 0: 'None', 1: 'NTP', 2: 'Parent', 3: 'Child' };

  return (
    <Filters>
      <Filter type="text" name="search" title="Search" placeholder="Search devices" />
      <Filter
        type="preset"
        preset="defaultDevice"
        name="is_default"
        title="default device"
        data={is_default}
      />

      <div className="filter-title">Device status</div>

      <Filter type="checkbox" name="online_status" title="Online status" data={online_status} />
      <Filter
        type="checkbox"
        name="download_status"
        title="Download status"
        data={download_status}
      />
      {p.atLeastTierProOrSuperUser && (
        <Filter type="dropdown" name="health_status" title="Health status" data={health_status} />
      )}
      <Filter type="dropdown" name="version" title="Player version" data={version} />
      <Filter
        type="dropdown"
        name="firmware_version"
        title="Firmware version"
        data={firmware_version}
      />
      <Filter type="dropdown" name="device_type" title="Device type" data={device_type} />
      <div className={showMoreFilters ? '' : 'hidden'}>
        <Filter
          type="preset"
          preset="prestagedDevices"
          name="prestaged"
          title="Prestage status"
          data={prestaged}
        />
        <div className="filter-title">General</div>
        <Filter
          type="dropdown"
          name="download_interval"
          title="Download interval"
          data={download_interval}
        />
        <Filter
          type="dropdown"
          name="hardware_rotation"
          title="Hardware rotation"
          data={hardware_rotation}
        />
        <Filter type="dropdown" name="rotation" title="Software rotation" data={rotation} />
        <Filter
          type="dropdown"
          name="viewport_top_left"
          title="Draw at top left"
          data={viewport_top_left}
        />
        <Filter type="dropdown" name="fps_limit" title="Max frame rate" data={fps_limit} />
        <Filter
          type="dropdown"
          name="commander_enabled"
          title="Commander"
          data={commander_enabled}
          text={enabledText}
        />
        <Filter
          type="dropdown"
          name="override_download_schedule"
          title="Override download schedule"
          data={override_download_schedule}
          text={enabledText}
        />
        <div className="filter-title">Video Wall</div>
        <Filter
          type="dropdown"
          name="synchronisation_method"
          title="Sync method"
          data={synchronisation_method}
          text={syncText}
        />
        <Filter type="dropdown" name="sync_tag" title="Sync tag" data={sync_tag} />
        <Filter type="dropdown" name="time_sync" title="NTP server" data={time_sync} />
        <Filter
          type="dropdown"
          name="vw_enabled"
          title="Video wall"
          data={vw_enabled}
          text={enabledText}
        />
        <Filter type="dropdown" name="vw_left" title="Video wall panel left" data={vw_left} />
        <Filter type="dropdown" name="vw_top" title="Video wall panel top" data={vw_top} />
        <Filter type="dropdown" name="vw_width" title="Video wall panel width" data={vw_width} />
        <Filter type="dropdown" name="vw_height" title="Video wall panel height" data={vw_height} />
        <Filter
          type="dropdown"
          name="vw_wall_width"
          title="Video wall width"
          data={vw_wall_width}
        />
        <Filter
          type="dropdown"
          name="vw_wall_height"
          title="Video wall height"
          data={vw_wall_height}
        />

        <div className="filter-title">Power Schedules</div>
        <Filter
          type="dropdown"
          name="restart_enabled"
          title="Scheduled reboot"
          data={restart_enabled}
          text={enabledText}
        />
        <div className="dual">
          <Filter type="dropdown" name="restart_hour" title="Reboot hour" data={restart_hour} />
          <Filter type="dropdown" name="restart_min" title="Reboot min" data={restart_min} />
        </div>
        <Filter
          type="dropdown"
          name="power_schedule_enabled"
          title="Scheduled on/off"
          data={power_schedule_enabled}
          text={enabledText}
        />
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_mon_1_on"
            title="Mon on"
            data={power_schedule_mon_1_on}
          />
          <Filter
            type="dropdown"
            name="power_schedule_mon_1_off"
            title="Mon off"
            data={power_schedule_mon_1_off}
          />
        </div>
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_tue_1_on"
            title="Tue on"
            data={power_schedule_tue_1_on}
          />
          <Filter
            type="dropdown"
            name="power_schedule_tue_1_off"
            title="Tue off"
            data={power_schedule_tue_1_off}
          />
        </div>
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_wed_1_on"
            title="Wed on"
            data={power_schedule_wed_1_on}
          />
          <Filter
            type="dropdown"
            name="power_schedule_wed_1_off"
            title="Wed off"
            data={power_schedule_wed_1_off}
          />
        </div>
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_thu_1_on"
            title="Thu on"
            data={power_schedule_thu_1_on}
          />
          <Filter
            type="dropdown"
            name="power_schedule_thu_1_off"
            title="Thu off"
            data={power_schedule_thu_1_off}
          />
        </div>
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_fri_1_on"
            title="Fri on"
            data={power_schedule_fri_1_on}
          />
          <Filter
            type="dropdown"
            name="power_schedule_fri_1_off"
            title="Fri off"
            data={power_schedule_fri_1_off}
          />
        </div>
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_sat_1_on"
            title="Sat on"
            data={power_schedule_sat_1_on}
          />
          <Filter
            type="dropdown"
            name="power_schedule_sat_1_off"
            title="Sat off"
            data={power_schedule_sat_1_off}
          />
        </div>
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_sun_1_on"
            title="Sun on"
            data={power_schedule_sun_1_on}
          />
          <Filter
            type="dropdown"
            name="power_schedule_sun_1_off"
            title="Sun off"
            data={power_schedule_sun_1_off}
          />
        </div>
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_extra_1_key"
            title="option 1: key"
            data={power_schedule_extra_1_key}
          />
          <Filter
            type="dropdown"
            name="power_schedule_extra_1_val"
            title="option 1: value"
            data={power_schedule_extra_1_val}
          />
        </div>
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_extra_2_key"
            title="option 2: key"
            data={power_schedule_extra_2_key}
          />
          <Filter
            type="dropdown"
            name="power_schedule_extra_2_val"
            title="option 2: value"
            data={power_schedule_extra_2_val}
          />
        </div>
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_extra_3_key"
            title="option 3: key"
            data={power_schedule_extra_3_key}
          />
          <Filter
            type="dropdown"
            name="power_schedule_extra_3_val"
            title="option 3: value"
            data={power_schedule_extra_3_val}
          />
        </div>
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_extra_4_key"
            title="option 4: key"
            data={power_schedule_extra_4_key}
          />
          <Filter
            type="dropdown"
            name="power_schedule_extra_4_val"
            title="option 4: value"
            data={power_schedule_extra_4_val}
          />
        </div>
        <div className="dual">
          <Filter
            type="dropdown"
            name="power_schedule_extra_5_key"
            title="option 5: key"
            data={power_schedule_extra_5_key}
          />
          <Filter
            type="dropdown"
            name="power_schedule_extra_5_val"
            title="option 5: value"
            data={power_schedule_extra_5_val}
          />
        </div>

        <div className="filter-title">Diagnostics</div>
        <Filter
          type="dropdown"
          name="debug_toast"
          title="Overlay diagnostics"
          data={debug_toast}
          text={enabledText}
        />
        <Filter
          type="dropdown"
          name="save_errors"
          title="Save errors"
          data={save_errors}
          text={enabledText}
        />
        <Filter
          type="dropdown"
          name="show_progress"
          title="Download progress"
          data={show_progress}
          text={enabledText}
        />
        <Filter
          type="dropdown"
          name="error_marker"
          title="Error marker"
          data={error_marker}
          text={enabledText}
        />
        <Filter
          type="dropdown"
          name="network_status_marker"
          title="Network marker"
          data={network_status_marker}
          text={enabledText}
        />
        <Filter
          type="dropdown"
          name="show_stats"
          title="Statistics overlay"
          data={show_stats}
          text={enabledText}
        />
        <Filter
          type="dropdown"
          name="network_watchdog"
          title="Network watchdog"
          data={network_watchdog}
          text={enabledText}
        />
        <Filter
          type="dropdown"
          name="healthcheck_config_name"
          title="Healthcheck config"
          data={healthcheck_config_name}
        />

        <div className="filter-title">External</div>
        <Filter
          type="dropdown"
          name="allow_external_update"
          title="3rd party updates"
          data={allow_external_update}
          text={enabledText}
        />
        <Filter
          type="dropdown"
          name="broadcast"
          title="Broadcast"
          data={broadcast}
          text={enabledText}
        />
        <Filter
          type="dropdown"
          name="broadcast_port"
          title="Broadcast port"
          data={broadcast_port}
        />

        <div className="filter-title">Metadata</div>
        <Filter
          type="checkbox"
          name="createdBy"
          title="Registered by"
          data={createdBy}
          users={users}
        />
        <Filter type="preset" name="createdDate" title="Registered date" preset="daterange" />
        <Filter
          type="checkbox"
          name="modifiedBy"
          title="Modified by"
          data={modifiedBy}
          users={users}
        />
        <Filter type="preset" name="modifiedDate" title="Modified date" preset="daterange" />
        <Filter type="tag" name="tags" title="Tags" data={tags} />
      </div>
      <div className="filters-more">
        {p.atLeastTierProOrSuperUser && (
          <Button bsSize="xsmall" onClick={toggleMoreFilters}>
            Show {showMoreFilters ? 'less' : 'more'} filters
          </Button>
        )}
      </div>
    </Filters>
  );
}

DeviceFilters.propTypes = {
  auth: PropTypes.object.isRequired,
  users: PropTypes.object.isRequired,
  devices: PropTypes.object.isRequired,
  showMoreFilters: PropTypes.bool.isRequired,
  toggleMoreFilters: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
  auth: state.auth,
  users: state.users,
  devices: state.devices,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceFilters);
